export default "__VITE_ASSET__BmUkc_Y8__ 400w, __VITE_ASSET__CQednuxG__ 800w, __VITE_ASSET__B0Mst8gW__ 1024w";